import React from 'react';
import { MessageCircle } from 'lucide-react';
export const FloatingWhatsApp = () => {
  return <div className="fixed bottom-6 right-6 z-50 group" data-id="element-39">
      {/* Tooltip */}
      <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-white text-brand-dark px-4 py-2 rounded-2xl shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap font-medium text-sm" data-id="element-40">
        ¡Chateanos!
        <div className="absolute top-1/2 -right-2 -translate-y-1/2 border-8 border-transparent border-l-white" data-id="element-41"></div>
      </div>

      {/* Button */}
      <a href="#" className="relative flex items-center justify-center w-16 h-16 bg-[#25D366] text-white rounded-full shadow-xl hover:scale-110 transition-transform duration-300" data-id="element-42">
        <MessageCircle size={32} data-id="element-43" />
        {/* Pulse effect */}
        <div className="absolute inset-0 rounded-full border-2 border-[#25D366] animate-ping opacity-75" data-id="element-44"></div>
      </a>
    </div>;
};